
import { ApplicationErrorType } from "./application-error.types";
import { ApplicationError } from "./application-error";

/**
 * Extension of the ApplicationError class for Http errors
 */
export class RuntimeApplicationError extends ApplicationError
{
    //#region Constructor

    /**
     * Class constructor
     * @param errorMessage text description of error
     * @param device device info
     * @param applicationVersion application version
     * @param softwareVersion os version
     * @param userAgent agent used (android, ios)
     * @param errorStackTrace error tracing
     */
    constructor
        (
            errorMessage,
            device: string,
            applicationVersion: string,
            softwareVersion: string,
            userAgent: string,
            errorStackTrace: string
        )
    {
        super(`Unhandled runtime exception: ${errorMessage}`, ApplicationErrorType.ERROR_RUNTIME, device, applicationVersion, softwareVersion, userAgent);
        this.ErrorStackTrace = errorStackTrace;
    }

    //#endregion

    //#region Methods

    /**
     * Error stack trace
     */
    private ErrorStackTrace: string;

    //#endregion
}